import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";

import { AuthenticationService } from "../../../core/services/auth.service";
import { AuthfakeauthenticationService } from "../../../core/services/authfake.service";

import { ActivatedRoute, Router } from "@angular/router";
import { OwlOptions } from "ngx-owl-carousel-o";
import { toDataURL } from "qrcode";

@Component({
    selector: "app-login2",
    templateUrl: "./login2.component.html",
    styleUrls: ["./login2.component.scss"],
    standalone: false
})
/**
 * Login-2 component
 */
export class Login2Component implements OnInit {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private authFackservice: AuthfakeauthenticationService
  ) {}
  loginForm: UntypedFormGroup;
  submitted = false;
  error = "";
  returnUrl: string;
  type: string = "password";
  show: boolean = false;

  // Second factor. The password check only yields a short-lived mfa-token;
  // access tokens are issued by /auth/mfa/verify.
  step: "credentials" | "mfa" = "credentials";
  mfaMode: "verify" | "setup" = "verify";
  mfaToken = "";
  secret = "";
  qrDataUrl = "";
  code = "";
  verifying = false;

  // set the currenr year
  year: number = new Date().getFullYear();

  ngOnInit(): void {
    document.body.classList.add("auth-body-bg");
    this.loginForm = this.formBuilder.group({
      email: ["", [Validators.required, Validators.email]],
      password: ["", [Validators.required]],
    });

    // reset login status
    // this.authenticationService.logout();
    // get return url from route parameters or default to '/'
    // tslint:disable-next-line: no-string-literal
    this.returnUrl = this.route.snapshot.queryParams["returnUrl"] || "/";
  }

  carouselOption: OwlOptions = {
    items: 1,
    loop: false,
    margin: 0,
    nav: false,
    dots: true,
    responsive: {
      680: {
        items: 1,
      },
    },
  };

  // convenience getter for easy access to form fields
  get f() {
    return this.loginForm.controls;
  }

  /**
   * Form submit
   */
  onSubmit() {
    this.submitted = true;
    this.error = "";

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }

    this.authenticationService
      .signIn({ email: this.f.email.value, password: this.f.password.value })
      .subscribe(
        async (res: any) => {
          const attrs = (res && res.data && res.data.attributes) || {};
          if (attrs["access-token"]) {
            // Backend without 2FA enabled: legacy direct token response.
            this.finishSignIn(attrs);
            return;
          }
          this.mfaToken = attrs["mfa-token"] || "";
          if (!this.mfaToken) {
            this.error = "Sign in failed: the server did not start a 2FA session.";
            return;
          }
          this.mfaMode = attrs["mode"] === "setup" ? "setup" : "verify";
          this.secret = attrs["secret"] || "";
          this.qrDataUrl = "";
          if (attrs["otpauth-url"]) {
            try {
              this.qrDataUrl = await toDataURL(attrs["otpauth-url"], { width: 200, margin: 1 });
            } catch {
              this.qrDataUrl = "";
            }
          }
          this.code = "";
          this.step = "mfa";
        },
        (error) => {
          console.log(error);
          this.error = "Wrong email or password.";
        }
      );
  }

  onVerify() {
    const code = (this.code || "").replace(/\s+/g, "");
    if (!/^\d{6}$/.test(code)) {
      this.error = "Enter the 6-digit code from your authenticator app.";
      return;
    }
    this.verifying = true;
    this.error = "";
    this.authenticationService.mfaVerify({ mfaToken: this.mfaToken, code }).subscribe(
      (res: any) => {
        this.verifying = false;
        this.finishSignIn((res && res.data && res.data.attributes) || {});
      },
      (err: any) => {
        this.verifying = false;
        const status = err && err.status;
        const message = err && err.error && typeof err.error.message === "string" ? err.error.message : "";
        if (status === 403) {
          this.error = "Too many wrong codes. Wait a few minutes and try again.";
        } else if (status === 401 && /sign in again/i.test(message)) {
          this.backToCredentials();
          this.error = "Your 2FA session expired. Sign in again.";
        } else if (status === 401) {
          this.error = /already used/i.test(message) ? "That code was already used. Wait for the next one." : "Wrong code.";
        } else {
          this.error = "Could not verify the code. Try again.";
        }
      }
    );
  }

  backToCredentials() {
    this.step = "credentials";
    this.mfaToken = "";
    this.secret = "";
    this.qrDataUrl = "";
    this.code = "";
    this.error = "";
    this.verifying = false;
  }

  private finishSignIn(attrs: any) {
    const token = attrs["access-token"];
    if (!token) {
      this.error = "Sign in failed: the server did not return a token.";
      return;
    }
    localStorage.setItem("token", token);
    this.authenticationService.getSelf().subscribe((data: any) => {
      localStorage.setItem("userId", JSON.stringify(data.data.attributes));
      localStorage.setItem("user", JSON.stringify(data.data.attributes));
      this.router.navigate(["/dashboards"]);
    });
  }

  onShow() {
    this.show = !this.show;
    if (!this.show) {
      this.type = "password";
    } else {
      this.type = "text";
    }
  }
}
